import * as React from 'react'
import styled from 'styled-components'
import { ConfigUiHint, JsonSchema } from '../../../types'

type Props = {
  label: string
  value: string
  schema: JsonSchema
  hint?: ConfigUiHint
  disabled?: boolean
  onChange: (val: string) => void
}

const Wrapper = styled.div`
  margin-bottom: 16px;
`

const Label = styled.label`
  display: block;
  color: ${(p) => p.theme.label};
  font-size: 12px;
  margin-bottom: 4px;
  font-family: 'NunitoSansSemiBold';
`

const Select = styled.select`
  background: ${(p) => p.theme.input.default};
  border: none;
  border-radius: ${(p) => p.theme.radius};
  color: ${(p) => p.theme.white};
  padding: 10px 32px 10px 12px;
  font-size: 14px;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  appearance: none;
  cursor: pointer;
  min-height: 44px;
  background-image: ${(p) => {
    const fill = encodeURIComponent(String(p.theme.white))
    return `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3e%3cpath fill='${fill}' d='M5 6L0 0h10z'/%3e%3c/svg%3e")`
  }};
  background-repeat: no-repeat;
  background-position: right 12px center;

  &:focus { box-shadow: 0 0 0 2px ${(p) => p.theme.accent}; outline: none; }
  &:disabled {
    background: ${(p) => p.theme.input.disabled};
    cursor: not-allowed;
  }

  option {
    background: ${(p) => p.theme.drop.options};
    color: ${(p) => p.theme.white};
  }
`

const HelpText = styled.span`
  display: block;
  color: ${(p) => p.theme.listDesc};
  font-size: 12px;
  margin-top: 4px;
`

export function SelectField({ label, value, schema, hint, disabled, onChange }: Props) {
  const options = schema.enum ?? []
  return (
    <Wrapper>
      <Label>{label}</Label>
      <Select
        value={value ?? ''}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">-- Select --</option>
        {options.map((opt) => (
          <option key={String(opt)} value={String(opt)}>
            {String(opt)}
          </option>
        ))}
      </Select>
      {hint?.help && <HelpText>{hint.help}</HelpText>}
    </Wrapper>
  )
}
